import React from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
/**
 * @component
 * Non-styled component for formatting a date string. It uses the
 * [`date-fns`](https://date-fns.org) library behind the scenes and accepts all
 * [format options](https://date-fns.org/v2.12.0/docs/format).
 */

var FormattedDate = function FormattedDate(props) {
  var date = props.children;
  if (typeof date === 'string') date = parseISO(date);
  return /*#__PURE__*/React.createElement("time", {
    dateTime: date,
    title: format(date, 'MMM d, yyyy, h:mm aa')
  }, format(date, props.format));
};

FormattedDate.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  format: PropTypes.string
};
FormattedDate.defaultProps = {
  children: new Date(),
  format: 'MMM d, yyyy'
};
export default FormattedDate;